/*
 * Datazoom, Inc ("COMPANY") CONFIDENTIAL
 * Copyright (c) 2017-2018 [Datazoom, Inc.], All Rights Reserved.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 */

import { combineReducers } from "redux";
import auth from "./auth/reducer";
import connector from "./connector/reducer";
import collector from "./collector/reducer";
import datapipe from "./datapipe/reducer";
import aggregate from "./aggregate/reducer";
import player from "./player/reducer";
import company from "./company/reducer";
import user from "./user/reducer";
import analytic from "./analytic/reducer";
import ui from "./ui/reducer";
import notification from "./notification/reducer";
import customer from "./customer/reducer";
import datadictionary from "./datadictionary/reducer";
import project from "./project/reducer";
import customdata from "./customdata/reducer";
import collectorManagement from "./collectorMgmt/reducer";

export default combineReducers({
  auth,
  connector,
  collector,
  datapipe,
  aggregate,
  player,
  company,
  user,
  analytic,
  ui,
  notification,
  customer,
  datadictionary,
  project,
  customdata,
  collectorManagement,
});
